const PopupIcon = ({ title, className }) => {
  return (
    <div className={className}>
      <div className="flex w-[720px] justify-between py-6">
        <div className=" font-pop text-sm font-semibold text-darkGreen">
          {title}
        </div>
        <div className="flex justify-end gap-x-5">
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/facebook.png"
            alt="facebook"
          />
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/messenger.png"
            alt="messenger"
          />
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/instagram.png"
            alt="instagram"
          />
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/whatsapp.png"
            alt="whatsapp"
          />
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/frame.png"
            alt="frame"
          />
          <img
            className="h-5 w-5 cursor-pointer"
            src="assets/images/auction_listing/group.png"
            alt="group"
          />
        </div>
      </div>
    </div>
  );
};

export default PopupIcon;
